import { isNil } from 'lodash';
import { isEmpty } from './basic';
import { EMPTY_TEXT, matcher, getValueAfterCheckEmpty } from './string';

// const unit = {
//   percent: '%',
//   celsius: '℃',
//   byte: 'Byte',
//   KB: 'KB',
//   MB: 'MB',
//   GB: 'GB',
//   pps: 'pps',
//   Kpps: 'Kpps',
//   Mpps: 'Mpps',
//   Gpps: 'Gpps',
//   bps: 'bps',
//   Kbps: 'Kbps',
//   Mbps: 'Mbps',
//   Gbps: 'Gpbs',
//   toFixedbps: 'toFixedbps',
//   sec: 'sec',
//   ms: 'ms',
//   count: 'count',
//   count_s: 'count/s',
//   count_sec: 'count/sec',
//   Flush_s: 'Flush/s',
//   MHz: 'MHz',
//   GHz: 'GHz',
//   mos: 'mos',
//   fdf_count: 'fdf_count',
// };

// bps/pps 단위 (트래픽/대역폭)는 1000, 그 외 디스크 용량 / 메모리 용량과 같은 Byte 단위는 1024로 단위를 환산한다.
export const DECIMAL_DIVISOR = 1000;
export const BINARY_DIVISOR = 1024;
export const DEFAULT_DECIMAL_POINT = 2;

export function isNumber(value) {
  return !isEmpty(value) && isFinite(value);
}

export function getUnitData(unit) {
  let fractionDigits;
  let divisor;
  let unitText;
  let prefixUnit;

  switch (unit) {
    case 'count':
      fractionDigits = 0;
      divisor = null;
      unitText = '개';
      prefixUnit = null;
      break;
    case '%':
      fractionDigits = 2;
      divisor = null;
      unitText = '%';
      prefixUnit = null;
      break;
    case '℃':
      fractionDigits = 2;
      divisor = null;
      unitText = '℃';
      prefixUnit = null;
      break;
    case 'Byte':
      fractionDigits = 2;
      divisor = BINARY_DIVISOR;
      unitText = 'Byte';
      prefixUnit = null;
      break;
    case 'KB':
      fractionDigits = 2;
      divisor = BINARY_DIVISOR;
      unitText = 'Byte';
      prefixUnit = 'K';
      break;
    case 'MB':
      fractionDigits = 2;
      divisor = BINARY_DIVISOR;
      unitText = 'Byte';
      prefixUnit = 'M';
      break;
    case 'GB':
      fractionDigits = 2;
      divisor = BINARY_DIVISOR;
      unitText = 'Byte';
      prefixUnit = 'G';
      break;
    case 'sec':
      fractionDigits = 0;
      divisor = null;
      unitText = '초';
      prefixUnit = null;
      break;
    case 'ms':
      fractionDigits = 1;
      divisor = null;
      unitText = 'ms';
      prefixUnit = null;
      break;
    case 'pps':
      fractionDigits = 2;
      divisor = DECIMAL_DIVISOR;
      unitText = 'pps';
      prefixUnit = null;
      break;
    case 'Kpps':
      fractionDigits = 2;
      divisor = DECIMAL_DIVISOR;
      unitText = 'pps';
      prefixUnit = 'K';
      break;
    case 'Mpps':
      fractionDigits = 2;
      divisor = DECIMAL_DIVISOR;
      unitText = 'pps';
      prefixUnit = 'M';
      break;
    case 'Gpps':
      fractionDigits = 2;
      divisor = DECIMAL_DIVISOR;
      unitText = 'pps';
      prefixUnit = 'G';
      break;
    case 'bps':
      fractionDigits = 2;
      divisor = DECIMAL_DIVISOR;
      unitText = 'bps';
      prefixUnit = '';
      break;
    case 'Kbps':
      fractionDigits = 2;
      divisor = DECIMAL_DIVISOR;
      unitText = 'bps';
      prefixUnit = 'K';
      break;
    case 'Mbps':
      fractionDigits = 2;
      divisor = DECIMAL_DIVISOR;
      unitText = 'bps';
      prefixUnit = 'M';
      break;
    case 'Gbps':
      fractionDigits = 2;
      divisor = DECIMAL_DIVISOR;
      unitText = 'bps';
      prefixUnit = 'G';
      break;
    case 'toFixedbps':
      fractionDigits = 0;
      divisor = DECIMAL_DIVISOR;
      unitText = 'bps';
      prefixUnit = null;
      break;
    case 'count/s':
      fractionDigits = 0;
      divisor = null;
      unitText = 'count/s';
      prefixUnit = null;
      break;
    case 'count/sec':
      fractionDigits = 1;
      divisor = null;
      unitText = 'count/sec';
      prefixUnit = null;
      break;
    case 'Flush/s':
      fractionDigits = 2;
      divisor = null;
      unitText = 'Flush/s';
      prefixUnit = '';
      break;
    case 'MHz':
      fractionDigits = 2;
      divisor = DECIMAL_DIVISOR;
      unitText = 'Hz';
      prefixUnit = 'M';
      break;
    case 'GHz ':
      fractionDigits = 2;
      divisor = DECIMAL_DIVISOR;
      unitText = 'Hz';
      prefixUnit = 'G';
      break;
    case 'mos':
      fractionDigits = 0;
      divisor = null;
      unitText = 'mos';
      prefixUnit = null;
      break;
    case 'fdf_count':
      fractionDigits = 0;
      divisor = DECIMAL_DIVISOR;
      unitText = '개';
      prefixUnit = null;
      break;
    default:
      fractionDigits = DEFAULT_DECIMAL_POINT;
      divisor = DECIMAL_DIVISOR;
      unitText = unit;
      prefixUnit = null;
      break;
  }

  const unitData = {
    fractionDigits,
    divisor,
    unitText,
    prefixUnit,
    unit,
  };

  return unitData;
}

export function convertThousandSeparatorFormat(value) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function convertValueWithMetricPrefix(value, unitText, fractionDigits, divisor, prefixUnit, thousandSeparator, preciseNumericType) {
  let resultValue = value;
  let digitsValue = fractionDigits;
  let divisorValue = divisor;

  if (isNumber(value)) {
    resultValue = parseFloat(value);
  } else if (typeof (value) !== 'number') {
    return EMPTY_TEXT;
  }

  if (isEmpty(fractionDigits)) {
    digitsValue = DEFAULT_DECIMAL_POINT;
  }

  if (isEmpty(divisor)) {
    divisorValue = DECIMAL_DIVISOR;
  }

  let calcValue = '';
  let metricPrefix = '';
  let units = ['', 'K', 'M', 'G', 'T', 'P'];
  if (!isEmpty(prefixUnit) && units.indexOf(prefixUnit) > 0) {
    units = units.slice(units.indexOf(prefixUnit));
  }

  let i;
  if (resultValue >= 0 && resultValue < 1) {
    i = 0;
  } else {
    // 값에 맞는 단위 index 구함.
    const valueForIndex = resultValue < 0 ? resultValue * -1 : resultValue;
    i = parseInt(Math.floor(Math.log(valueForIndex) / Math.log(divisorValue)), 10);
    if (i >= units.length) {
      i = units.length - 1;
    }
  }

  metricPrefix = units[i];
  /* eslint-disable no-restricted-properties */
  calcValue = (resultValue / Math.pow(divisorValue, i)); // FIXME eslint
  /* eslint-enable no-restricted-properties */
  if (isEmpty(preciseNumericType) || preciseNumericType) {
    if (!matcher.integer().test(calcValue)) {
      calcValue = calcValue.toFixed(digitsValue);
    }
  } else {
    calcValue = calcValue.toFixed(digitsValue);
  }

  if (isEmpty(thousandSeparator) || thousandSeparator) {
    calcValue = convertThousandSeparatorFormat(calcValue);
  }

  if (isEmpty(unitText)) {
    return isEmpty(metricPrefix) ? calcValue : `${calcValue} ${metricPrefix}`;
  }
  return `${calcValue} ${metricPrefix}${unitText}`;
}

// before: value, unit, unitText, fractionDigits, divisor, thousandSeparator, preciseNumericType, prefixUnit
// after: value, unit, unitText, fractionDigits, divisor, prefixUnit, thousandSeparator, preciseNumericType
export function convertValueByUnitData(value, unit, unitText, fractionDigits, divisor, prefixUnit, thousandSeparator, preciseNumericType) {
  let resultValue = value;
  let digitsValue = fractionDigits;
  let unitValue = unitText;
  if (!isEmpty(divisor) && divisor > 1) {
    resultValue = convertValueWithMetricPrefix(value, unitText, fractionDigits, divisor, prefixUnit, thousandSeparator, preciseNumericType);
  } else {
    if (isNumber(value)) {
      resultValue = parseFloat(value);
    } else if (typeof (value) !== 'number') {
      return EMPTY_TEXT;
    }

    if (isEmpty(fractionDigits)) {
      digitsValue = DEFAULT_DECIMAL_POINT;
    }

    if (isEmpty(fractionDigits)) {
      const unitData = getUnitData(unit);

      if (isEmpty(unitText)) {
        unitValue = unitData.unitText;
      }
      if (isEmpty(fractionDigits)) {
        digitsValue = unitData.fractionDigits;
      }
      if (isEmpty(prefixUnit)) {
        unitValue = unitData.prefixUnit;
      }
    }

    let calcValue = resultValue;

    if (isEmpty(preciseNumericType) || preciseNumericType) {
      if (!matcher.integer().test(calcValue)) {
        calcValue = calcValue.toFixed(digitsValue);
      }
    } else {
      calcValue = calcValue.toFixed(digitsValue);
    }

    if (isEmpty(thousandSeparator) || thousandSeparator) {
      calcValue = convertThousandSeparatorFormat(calcValue);
    }

    resultValue = isEmpty(unitValue) ? calcValue : calcValue + unitValue;
  }

  return getValueAfterCheckEmpty(resultValue);
}

/**
 * 단위를 변환한다.
 * @author jeee12
 * @param  {[type]} value              단위 변환 전의 최초 값
 * @param  {[type]} unit               단위
 * @param  {[type]} thousandSeparator  천단위 (,) 분리 여부
 * @param  {[type]} preciseNumericType
 * @param  {[type]} noUnitText         단위 변환된 String에 unit의 표현 여부 (ex. K or Kbps)
 * @param {Number} fractionDigits      소수점 자리
 * @return {String}                    단위 변환된 값 (String)
 */
export function convertValuByUnit(value, unit, thousandSeparator, preciseNumericType, noUnitText, fractionDigits) {
  const unitData = getUnitData(unit);
  let unitText;
  if (noUnitText) {
    unitText = null;
  } else {
    unitText = unitData.unitText;
  }
  const digitValue = isNil(fractionDigits) ? unitData.fractionDigits : fractionDigits;
  return convertValueByUnitData(value, unit, unitText, digitValue, unitData.divisor, unitData.prefixUnit, thousandSeparator, preciseNumericType);
}

export function convertDefaultNumberFormat(value, fractionDigits) {
  let formatValue;
  if (isNumber(value) === true) {
    if (matcher.integer().test(value)) {
      formatValue = convertThousandSeparatorFormat(value);
    } else {
      let digitValue;
      if (isNil(fractionDigits)) {
        digitValue = DEFAULT_DECIMAL_POINT;
      } else {
        digitValue = fractionDigits;
      }
      const calcValue = `${parseFloat(value).toFixed(digitValue)}`;
      const floatValue = calcValue.split('.');
      formatValue = `${convertThousandSeparatorFormat(floatValue[0])}.${floatValue[1]}`;
    }
  } else {
    formatValue = value;
  }
  return formatValue;
}

export function convertMillisecondsToSeconds(value) {
  let calcValue = parseFloat(value);
  if (calcValue >= 1000) {
    calcValue = (calcValue / 1000).toFixed(1);
    const floatValue = calcValue.split('.');
    return `${convertThousandSeparatorFormat(floatValue[0])}.${floatValue[1]}s`;
  }
  return convertValuByUnit(value, 'ms', true, true);
}

/**
 * 인터페이스의 대역폭(bps, pps) 단위로 변환합니다.
 * @author Hunui
 * @param  {[type]} value 대역폭 값
 * @return {[type]}       [description]
 */
export function convertValueForInterfaceSpeed(value) {
  if (isEmpty(value)) {
    return EMPTY_TEXT;
  } else if (value === -1) {
    return '-';
  } else if (value === -2) {
    return 'Auto';
  }
  return convertValuByUnit(value, 'bps', false, true, true);
}

export default {
  convertValuByUnit,
  convertValueByUnitData,
  convertValueWithMetricPrefix,
  getUnitData,
  isNumber,
  convertDefaultNumberFormat,
  convertMillisecondsToSeconds,
};



// WEBPACK FOOTER //
// ./src/utils/number.js